import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-013d1158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-container" }
const _hoisted_2 = { class: "tooltip" }
const _hoisted_3 = {
  key: 1,
  class: "fa fa-lock lock-icon"
}
const _hoisted_4 = { class: "label-text" }

import { computed } from "vue";
import { DxSwitch } from "devextreme-vue/switch";
import { DxTooltip } from "devextreme-vue/tooltip";


export default /*#__PURE__*/_defineComponent({
  __name: 'switch-toggle',
  props: {
  /**
   * The boolean, or number value used with `v-model` to control the visibility or state of a modal or component.
   * @type [number, boolean]
   * @required
   */
  modelValue: {
    type: [Number, Boolean],
    required: true,
  },
  /**
   * Determines whether the control is read only.
   * @type {boolean}
   * @default true
   */
  readOnly: {
    type: Boolean,
    default: true,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * The margin to bottom of component (for CSS styling).
   * @type {string}
   * @default '0.75rem'
   */
  marginBottom: {
    type: String,
    default: "0.75rem",
  },
  /**
   * The width to label (for CSS styling).
   * @type {string}
   * @default 'fit-content'
   */
  labelWidth: {
    type: String,
    default: "fit-content",
  },
  /**
   * Determines whether the label is required to change position.
   * @type {boolean}
   * @default false
   */
  isLabelPositionToEnd: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether the lock icon should be displayed.
   * @type {boolean}
   * @default false
   */
  displayLockIcon: {
    type: Boolean,
    default: false,
  },
  /**
   * Will display an info icon with a tip between the title and the toggle
   * @type {String}
   * @default ''
   */
  infoText: {
    type: String,
    default: "",
  },
  /**
   * We can display a custom icon immediately next to the label by passing the intended icon class.
   */
  customIcon: {
    type: String,
    default: "",
  },
  /**
   * The passed icon class we come with default styling but this can be changed using this colour prop.
   */
  customIconColour: {
    type: String,
    default: "",
  },
},
  emits: ["update:modelValue", "onVaueChange"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "2b1ece82": (props.marginBottom),
  "1fbc3b0a": (props.labelWidth)
}))




// Create a randomised infoId so that the tooltip can be separately bound to multiple switches
const infoId = `switch-info-${Math.random().toString(36).slice(2)}`;

const switchModel = computed({
  get: () => props.modelValue,
  set: (value: boolean | number) => emit("update:modelValue", value),
});

const onChange = (e: any) => {
  // Double not notation used to ensure a boolean value instead of a numeric conversion
  let newValue: boolean | number = !!e.value;

  // To avoid errors in parent components, ensure the new value matches the type of the original modelValue
  if (typeof props.modelValue === "number") {
    newValue = e.value ? 1 : 0;
  }

  switchModel.value = newValue;
  emit("onVaueChange", newValue);
};

// As the DxSwitch component requires a boolean, we must ensure the modelValue passed is converted to a boolean
const dxSwitchValue = computed(() => !!switchModel.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.isLabelPositionToEnd)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["label-wrapper", { 'disable-label': __props.readOnly }])
        }, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(__props.label) + " ", 1),
            (props.customIcon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  id: "custom-icon",
                  class: _normalizeClass(props.customIcon),
                  style: _normalizeStyle({
            color: props.customIconColour ? props.customIconColour : '',
          })
                }, null, 6))
              : _createCommentVNode("", true)
          ]),
          (props.infoText !== '')
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                id: infoId,
                class: "fas fa-info-circle info-icon"
              }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (props.infoText !== '')
        ? (_openBlock(), _createBlock(_unref(DxTooltip), {
            key: 0,
            target: `#${infoId}`,
            "show-event": { name: 'click' },
            position: { my: 'top center', at: 'bottom center' },
            "max-width": "200px",
            "hide-on-outside-click": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(props.infoText), 1)
              ])
            ]),
            _: 1
          }, 8, ["target"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(DxSwitch), {
      value: dxSwitchValue.value,
      onValueChanged: onChange,
      disabled: props.readOnly
    }, null, 8, ["value", "disabled"]),
    (props.readOnly && __props.displayLockIcon)
      ? (_openBlock(), _createElementBlock("i", _hoisted_3))
      : _createCommentVNode("", true),
    (__props.isLabelPositionToEnd)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["label-wrapper", { 'disable-label': __props.readOnly }])
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(__props.label) + " ", 1),
            (props.customIcon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  id: "custom-icon",
                  class: _normalizeClass(props.customIcon),
                  style: _normalizeStyle({
            color: props.customIconColour ? props.customIconColour : '',
          })
                }, null, 6))
              : _createCommentVNode("", true)
          ]),
          (props.infoText !== '')
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                id: infoId,
                class: "fas fa-info-circle info-icon"
              }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})